import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BasicSelect from 'dibs-elements/dist/BasicSelect';
import { injectIntl, intlShape, defineMessages } from 'react-intl';

class QuantitySelect extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);

        this.state = {
            quantity: '1',
        };
    }

    onChange(e) {
        this.setState({ quantity: e.target.value });
    }

    render() {
        const {
            children,
            intl,
            itemIsASet,
            maxValue,
            selectClassName,
            quantitySelectOptions,
        } = this.props;
        const { quantity } = this.state;

        const messages = defineMessages({
            placeholder: {
                id: 'global.quantitySelect.placeholder',
                defaultMessage: 'Quantity',
            },
            limitedSetLabel: {
                id: 'global.quantitySelect.limitedSetLabel',
                defaultMessage: '{quantity, plural, one {# set} other {# sets}}',
            },
        });

        const select = selectOptions => (
            <div>
                <div className={selectClassName}>
                    <BasicSelect
                        hasAnimatedPlaceholder
                        placeholder={intl.formatMessage(messages.placeholder)}
                        onChange={this.onChange}
                        value={quantity}
                        options={selectOptions}
                    />
                </div>
                {children(quantity)}
            </div>
        );

        if (quantitySelectOptions && quantitySelectOptions.length) {
            return select(quantitySelectOptions);
        } else if (maxValue > 1) {
            const options = [];
            if (itemIsASet) {
                for (let i = 1; i <= maxValue; i++) {
                    options.push({
                        value: i,
                        label: intl.formatMessage(messages.limitedSetLabel, { quantity: i }),
                    });
                }
            } else {
                for (let i = 1; i <= maxValue; i++) {
                    options.push({ value: i, label: intl.formatNumber(i) });
                }
            }

            return select(options);
        } else {
            return children(null);
        }
    }
}

QuantitySelect.propTypes = {
    children: PropTypes.func.isRequired,
    itemIsASet: PropTypes.bool,
    intl: intlShape.isRequired,
    maxValue: PropTypes.number,
    selectClassName: PropTypes.string,
    quantitySelectOptions: PropTypes.array,
};

export default injectIntl(QuantitySelect);



// WEBPACK FOOTER //
// ./assets/js/global/components/QuantitySelect.jsx